export default __webpack_public_path__ + "static/media/agentforce.1de38705.png";